export const wrapIfPresent = <
  P extends string,
  C extends string,
  S extends string,
>(
  prefix: P,
  content: C | undefined,
  suffix: S
): `${P}${C}${S}` | '' => {
  if (!content) return ''
  return `${prefix}${content}${suffix}`
}
